import { createMetaAccount, updateMetaAccount } from '@/API/repositories/meta';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useRef } from 'react';

const useMetaAccountForm = ({ setShow, account }) => {
	const { makeRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const emailRef = useRef();
	const accessTokenRef = useRef();

	const handleSubmit = async (e) => {
		e.preventDefault();

		const payload = {
			email: emailRef.current.value,
			access_token: accessTokenRef.current.value,
		};

		const response =
			Object.keys(account).length > 0
				? await makeRequest(updateMetaAccount.bind(null, payload, account._id))
				: await makeRequest(createMetaAccount.bind(null, payload));

		if (response?.data) {
			setShow(() => false);
			return addMessage('Saved', 'success');
		}

		addMessage('Something went wrong!', 'error');
	};

	return {
		handleSubmit,
		emailRef,
		accessTokenRef,
	};
};

export default useMetaAccountForm;
